import React from "react";

import { Icon } from "components";

export const VerificationOption = ({ label, iconName, className = "" }) => (
  <span className={`paragraph-m ${className}`}>
    <Icon iconName={iconName} size="s" className="icon inline margin-right-25" />
    {label}
  </span>
);
